import { HttpContextToken } from '@angular/common/http';

/** When true on an HTTP request, the global loader overlay is not shown. */
export const SKIP_GLOBAL_LOADER = new HttpContextToken<boolean>(() => false);
